<div class="row ml-1 mr-1 mt-5">
    <div class="col-md-1"></div>
    <div class="col-md-10">
        <app-find (eroor)="eroorrecibido = $event" (owner)="Ownerrecibido = $event" (repositories)="Repositoryrecibido = $event"></app-find>
    </div>
    <div class="col-md-1"></div>
</div>
<div class="row ml-1 mr-1">
    <div class="col-md-3"></div>
    <div class="col-md-6">

        <app-owner *ngIf="Ownerrecibido && !eroorrecibido" [owner]="Ownerrecibido"></app-owner>
    </div>
    <div class="col-md-3"></div>

</div>
<div class="row ml-1 mr-1">
    <div class="col-md-12">
        <app-card *ngIf="Repositoryrecibido && !eroorrecibido" [repositories]="Repositoryrecibido"></app-card>
    </div>
</div>
<div class="row ml-1 mr-1 mt-5">
    <div class="col-md-10 offset-1">
        <app-notfound *ngIf="eroorrecibido"></app-notfound>
    </div>
</div>